import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Routes, Navigate } from 'react-router-dom';
import './App.scss';
import Layout from './layout/Layout';
import Home from './pages/Home/Home';
import SignIn from './pages/SignIn/SignIn';
import Logout from './pages/Logout/Logout';
import { authCheckState } from './redux/actions/auth';
import UserCreate from './pages/User/UserCreate';
import './redux/actions/index';
import UserList from './pages/User/UserList';
import CreateItemForm from './pages/Items/CreateItemForm';
import ListItems from './pages/Items/ListItems';
import Provider from './pages/Provider/Provider';
import GridItems from './pages/Items/GridItems';
import ItemView from './pages/Items/ItemView';
import Item from './pages/Items/Item';
import ItemClients from './pages/Items/ItemClients';
import CreateQuotation from './pages/Quotation/CreateQuotation';
import CreateOffer from './pages/Offer/CreateOffer';
import OfferList from './pages/Offer/OfferList';
import QuotationList from './pages/Quotation/QuotationList';
import ImageItem from './pages/Items/ImageItem';
import ItemFile from './pages/Items/ItemFile';
import TakePhoto from './components/Item/TakePhoto';
import Report from './pages/Reports/Report';
import Category from './pages/Category/Category';
import ItemStorage from './pages/Items/ItemStorage';
import ClientList from './pages/Client';
import ClientForm from './pages/Client/subcomponents/ClientForm';
import ClientDetail from './pages/Client/subcomponents/ClientDetail';
import LeadList from './pages/Lead/LeadList';
import LeadBoard from './pages/Lead/index';
import { queryClient } from './api/queryClient';
import { QueryClientProvider } from 'react-query';
import ConfirmAlert from './components/ui/ConfirmAlert';
import EditItemForm from './pages/Items/EditItemForm';
import ColorList from './pages/Color';
import BrandList from './pages/Brand';
import ModelList from './pages/Brand/ModelList';
import VersionList from './pages/Brand/VersionList';
import CommentList from './pages/Comment';
import BannerList from './pages/Banner';
import FAQList from './pages/FAQ';
import ServiceList from './pages/Service';
import BlogList from './pages/Blog';
import Sales from './pages/Sales';
import Settings from './pages/Settings';
import ChangePassword from './pages/User/ChangePassword';
import { hasPermission, hasModuleAccess } from './utils/permissions';

class App extends Component {
  state = {};

  componentDidMount() {
    this.props.onTryAutoSignup();
  }
  render() {
    let routes = (
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );

    if (this.props.isAuthenticated) {
      const showDashboard = hasPermission('dashboard.view');

      routes = (
        <Routes>
          {/* Home / default redirect */}
          {showDashboard && <Route path="/" element={<Home />} />}
          {!showDashboard && hasPermission('items.create') && (
            <Route path="/" element={<Navigate to="/create-items" replace />} />
          )}

          {/* Auth utilities */}
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/sign-in" element={<Navigate to="/" replace />} />
          <Route path="/logout" element={<Logout />} />

          {/* Clients */}
          {hasModuleAccess('clients') && (
            <Route path="/client-list" element={<ClientList />} />
          )}
          {hasModuleAccess('clients') && (
            <Route path="/client-detail/:clientId" element={<ClientDetail />} />
          )}
          {(hasPermission('clients.create') || hasPermission('clients.edit')) && (
            <Route path="/client-form/:clientId?" element={<ClientForm />} />
          )}

          {/* Leads */}
          {hasModuleAccess('leads') && (
            <Route path="/lead-board" element={<LeadBoard />} />
          )}
          {hasModuleAccess('leads') && (
            <Route path="/lead-list" element={<LeadList />} />
          )}

          {/* Offers */}
          {hasModuleAccess('offers') && (
            <Route path="/offerlist" element={<OfferList />} />
          )}
          {hasModuleAccess('offers') && (
            <Route path="/item-offer" element={<CreateOffer />} />
          )}

          {/* Quotations */}
          {hasModuleAccess('quotations') && (
            <Route path="/quotationlist" element={<QuotationList />} />
          )}
          {hasModuleAccess('quotations') && (
            <Route path="/item-quotation" element={<CreateQuotation />} />
          )}

          {/* Sales */}
          {hasPermission('sales.view') && (
            <Route path="/sales" element={<Sales />} />
          )}

          {/* Reports */}
          {hasModuleAccess('reports') && (
            <Route path="/report" element={<Report />} />
          )}

          {/* Items / Inventory */}
          {hasPermission('items.list') && (
            <Route path="/items" element={<GridItems />} />
          )}
          {hasPermission('items.list') && (
            <Route path="/list-items" element={<ListItems />} />
          )}
          {hasPermission('items.create') && (
            <Route path="/create-items" element={<CreateItemForm />} />
          )}
          {hasPermission('items.edit') && (
            <Route path="/edit-item/:numerointerno" element={<EditItemForm />} />
          )}
          {hasModuleAccess('items') && (
            <Route path="/item" element={<ItemView />} />
          )}
          {hasModuleAccess('items') && (
            <Route path="/item-admin" element={<Item />} />
          )}
          {hasModuleAccess('items') && (
            <Route path="/item-client" element={<ItemClients />} />
          )}
          {hasPermission('items.edit') && (
            <Route path="/item-image/:numerointerno" element={<ImageItem />} />
          )}
          {hasModuleAccess('items') && (
            <Route path="/item-file" element={<ItemFile />} />
          )}
          {hasModuleAccess('items') && (
            <Route path="/item-photo/:numerointerno" element={<TakePhoto />} />
          )}
          {hasPermission('item_storage.view') && (
            <Route path="/item-storage" element={<ItemStorage />} />
          )}

          {/* Config: Users (managed from Settings > Usuarios tab) */}
          {hasPermission('users.create') && (
            <Route path="/create-user" element={<UserCreate />} />
          )}

          {/* Config: Providers */}
          {hasModuleAccess('providers') && (
            <Route path="/provider" element={<Provider />} />
          )}

          {/* Config: Categories */}
          {hasModuleAccess('categories') && (
            <Route path="/category" element={<Category />} />
          )}

          {/* Config: Colors */}
          {hasModuleAccess('colors') && (
            <Route path="/colors" element={<ColorList />} />
          )}

          {/* Config: Brands / Models / Versions */}
          {hasModuleAccess('brands') && (
            <Route path="/brands" element={<BrandList />} />
          )}
          {hasModuleAccess('brands') && (
            <Route path="/brands/:brandId/models" element={<ModelList />} />
          )}
          {hasModuleAccess('brands') && (
            <Route
              path="/brands/:brandId/models/:modelId/versions"
              element={<VersionList />}
            />
          )}

          {/* Config: Comments */}
          {hasModuleAccess('comments') && (
            <Route path="/comments" element={<CommentList />} />
          )}

          {/* Config: Banners */}
          {hasModuleAccess('banners') && (
            <Route path="/banners" element={<BannerList />} />
          )}

          {/* Config: FAQs */}
          {hasModuleAccess('faqs') && (
            <Route path="/faqs" element={<FAQList />} />
          )}

          {/* Config: Services */}
          {hasModuleAccess('services') && (
            <Route path="/services" element={<ServiceList />} />
          )}

          {/* Config: Blog */}
          {hasModuleAccess('blogs') && (
            <Route path="/blog" element={<BlogList />} />
          )}

          {/* Settings */}
          {(hasModuleAccess('settings') || hasPermission('roles.list')) && (
            <Route path="/settings" element={<Settings />} />
          )}

          {/* Fallback: redirect to first available page */}
          <Route
            path="*"
            element={<Navigate to={
              showDashboard ? '/' :
              hasPermission('items.create') ? '/create-items' :
              hasPermission('items.list') ? '/items' :
              hasModuleAccess('leads') ? '/lead-board' :
              hasModuleAccess('clients') ? '/client-list' :
              '/change-password'
            } replace />}
          />
        </Routes>
      );
    }

    return (
      <QueryClientProvider client={queryClient}>
        <ConfirmAlert />
        <Layout>{routes}</Layout>
      </QueryClientProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: localStorage.getItem('token') !== null,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onTryAutoSignup: () => dispatch(authCheckState()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
